import { call, put } from "redux-saga/effects";
import MergeCmsActions from "../reducers/MergeCmsRedux";

export function* getMergeCmsData(api, action) {
  const { cb } = action;
  try {
    const response = yield call(api.getContentCmsData);
    if (response.ok) {
      yield put(MergeCmsActions.mergeCmsDataSuccess(response.data.data));
      if (cb) cb(response.data.data);
    } else {
      yield put(MergeCmsActions.mergeCmsDataFailure());
    }
  } catch (err) {
    yield put(MergeCmsActions.mergeCmsDataFailure());
  }
}
